import { withRouter } from 'react-router-dom';
// import { getInternalApiPath } from '../../config/apis';
import { RouteComponentProps } from 'react-router';
import * as React from 'react';

class ZendeskLoginComponent extends React.Component<RouteComponentProps> {
  constructor(props) {
    super(props);
  }

  public render() {
    fetch('/api/v1/zendesk/access/dispatchlogin', {
      method: 'POST',
      redirect: 'follow',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ urlSearch: this.props.location.search }),
    })
      .then((res) =>
        res.json().then((json) => {
          if (typeof window !== 'undefined') {
            window.location.href = json.location;
          }

          return null;
        }),
      )
      .catch((error) => {
        // Assuming users are coming from the PROD environment (why?)
        if (typeof window !== 'undefined') {
          window.location.href = 'https://affiliates.expediagroup.com/affiliate-hub/zendesk/access';
        }

        return null;
      });

    return null;
  }
}

export const ZendeskLoginExecutor = withRouter(ZendeskLoginComponent);
